import { useRef, useState } from "react";

import Slider from "components/ui/slider";
import getBonusAmountInfo from "utils/bonus";
import getStringDateAvailableUntil from "../../helpers/getStringDateAvailableUntil";
import BonusGameCards from "../bonusGameCards";
import "./styles/index.scss";
import { BONUS_TYPE_TRANSLATION } from "constants/bonus.constants.js";
import { GAME_TYPE, GAME_TYPE_MAPPER } from "constants/game.constants.js";
import { useTranslation } from "react-i18next";
import { binaryToFlags } from "utils/binaryCalculations.js";
import isNullOrUndefined from "utils/typeChecks/isNullOrUndefined.js";
import isEmptyArray from "utils/typeChecks/isEmptyArray.js";

const MultiTypeBonusesCard = ({ bonuses, isMobile, isTablet, currencyCode, assignedGameTypes }) => {
	const { t } = useTranslation();
	const [currentIndex, setCurrentIndex] = useState(0);
	const sliderRef = useRef(null);

	const settings = {
		className: "center",
		slidesToScroll: 1,
		slideToShow: 1,
		infinite: true,
		dots: false,
		draggable: true,
		centerPadding: "60px",
		swipeToSlide: true,
		// eslint-disable-next-line no-dupe-keys
		afterChange: (index) => {
			setCurrentIndex(index);
		}
	};

	const getBonusGamesInfoText = ({ bonus }) => {
		if (isNullOrUndefined(assignedGameTypes) || isEmptyArray(assignedGameTypes)) {
			return "";
		}
		const allGames = binaryToFlags(assignedGameTypes, bonus.gameType);

		if (allGames.length === 1) {
			return t(`common.${GAME_TYPE_MAPPER[allGames[0]]}`);
		}

		if (Object.values(GAME_TYPE).length === allGames.length) {
			return t("common.allGames");
		}

		return `${allGames.length} ${t("bonus.games")}`;
	};

	return (
		<div className="vs--bonus-modal-notification-info-content vs--bonus-modal-notification-info-content-multi-type">
			<h3
				className="vs--bonus-modal-notification-info-title"
				dangerouslySetInnerHTML={{
					__html: t("bonus.youReceived").replace(
						"{info}",
						`<span class="purple-color">
									${bonuses.length} ${t("bonus.bonuses")}
								</span>`
					)
				}}
			></h3>
			<p className="vs--bonus-modal-notification-info-subtitle">
				{t("bonus.slideHereToSeeTheDetails")}
			</p>
			<div className="vs--bonus-modal-notification-info-content-multi-type-slider-pagination-controls">
				<button className="pagination-control-button" onClick={() => sliderRef.current?.slickPrev()}>
					<i className="ic_back vs--font-bigest"></i>
				</button>
				<span className="vs--ff-primary vs--fs-16 vs--fw-500 vs--title-white vs--text-align-center vs--mb-4">
					{(currentIndex % bonuses.length) + 1} / {bonuses.length}
				</span>
				<button className="pagination-control-button" onClick={() => sliderRef.current?.slickNext()}>
					<i className="ic_right vs--font-bigest"></i>
				</button>
			</div>
			<Slider
				sliderRef={sliderRef}
				settings={settings}
				className="vs--bonus-modal-notification-info-content-multi-type-slider"
				slideElementWrapperClassName="vs--bonus-modal-notification-info-content-multi-type-slider-slide"
				items={bonuses.map((bonus) => {
					const bonusTypeInfoText = t(BONUS_TYPE_TRANSLATION[bonus.bonusType]);
					const bonusGamesInfoText = getBonusGamesInfoText({ bonus });
					return (
						<div
							key={bonus.bonusId}
							className="vs--bonus-modal-notification-info-content-multi-type-slider-slide-element vs--pt-12 "
						>
							<h4
								className="vs--mb-12 vs--title-white vs--ff-primary vs--fw-500 vs--fs-16 vs--text-align-center"
								dangerouslySetInnerHTML={{
									__html: t("bonus.bonusTypeForGames")
										.replace("{bonusType}", `<span class="brand-color-text">${bonusTypeInfoText}</span>`)
										.replace("{games}", '<span class="vs--font-bold">' + bonusGamesInfoText + "</span>")
								}}
							></h4>
							<div className="vs--flex vs--flex-row vs--justify-center vs--align-center">
								<div className="vs--bonus-modal-notification-info-content-multi-type-slider-slide-info vs--flex vs--flex-col vs--justify-start vs--align-center">
									<span className="vs--bonus-modal-notification-info-content-multi-type-slider-slide-info-text vs--my-4 vs--ff-primary vs--fs-12 vs--fw-500 vs--tc-gray vs--tt-u">
										{t("bonus.amount")}
									</span>
									<span className="vs--ff-primary vs--fs-14 vs--fw-500 vs--title-white">
										{getBonusAmountInfo({ bonus, currencyCode })}
									</span>
								</div>
								<div className="vs--bonus-modal-notification-info-content-multi-type-slider-slide-separator vs--mx-32"></div>
								<div className="vs--bonus-modal-notification-info-content-multi-type-slider-slide-info vs--flex vs--flex-col vs--justify-start vs--align-center">
									<span className="vs--bonus-modal-notification-info-content-multi-type-slider-slide-info-text vs--my-4 vs--ff-primary vs--fs-12 vs--fw-500 vs--tc-gray vs--tt-u">
										{t("bonus.availability")}
									</span>
									<span className="vs--ff-primary vs--fs-14 vs--fw-500 vs--title-white">
										{getStringDateAvailableUntil({ bonus })}
									</span>
								</div>
							</div>
							<BonusGameCards
								key={bonus.bonusId}
								gameType={bonus.gameType}
								isMobile={isMobile}
								isTablet={isTablet}
							/>
						</div>
					);
				})}
			/>
		</div>
	);
};
export default MultiTypeBonusesCard;
